import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//引入elementui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入axios
import axios from 'axios'
//配置请求根路径
// 本机地址
// axios.defaults.baseURL = 'http://localhost:3000/'
// 远程后台地址
// axios.defaults.headers.post['Content-Type'] = 'application/json';
// axios.defaults.baseURL = 'https://www.duorou.ltd/api'
axios.defaults.baseURL = '/api'

// 挂在到Vue实例，后面可通过this调用
Vue.prototype.$http = axios;
//使用elementUI
Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
